import { FC } from 'react'
import cn from 'classnames'
import style from '@src/components/Payment/Payment.module.scss'

type PaymentProps = {
  date: string
  title: string
  period: string
  summa: number
  balance: number
  className?: string
}

const Payment: FC<PaymentProps> = ({
  date, title, period, summa, balance, className,
}) => (
  <div className={cn(style.payContainer, className)}>
    <div className={style.date}>{date}</div>
    <div className={style.title}>{title}</div>
    <div className={style.period}>
      <div className={style.titleMobile}>Период</div>
      {period}
    </div>
    <div className={style.arrival}>
      <div className={style.titleMobile}>Приход, руб.</div>
      {summa > 0 && summa}
    </div>
    <div className={style.spending}>
      <div className={style.titleMobile}>Расход, руб.</div>
      {summa < 0 && summa}
    </div>
    <div className={style.balance}>
      <div className={style.titleMobile}>Баланс</div>
      {balance}
    </div>
  </div>
)

export default Payment
